module.exports = "https://static.wagwalking.com/_next/static/images/DropIn_Desktop-a8aeac26562d80eb3037ddeecebcee23.png";